module.exports = __webpack_public_path__ + "assets/menu-chevron.b14c9b16.svg";